import { render, staticRenderFns } from "./BankNumber.vue?vue&type=template&id=15fc6a01"
import script from "./BankNumber.vue?vue&type=script&lang=js"
export * from "./BankNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports